import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';


const CareerCard = ({ job, location, id, imageUrl }) => {

  let navigate = useNavigate();

  return (
    <div
      className="bg-white rounded-xl shadow-lg overflow-hidden flex flex-col transition-transform duration-300 hover:scale-[1.02] transform"
      onClick={() => { navigate(`/career/${id}`) }}
    >
      {/* Image Section */}
      <div className="w-full h-48 sm:h-56 overflow-hidden">
        <img
          src={imageUrl}
          alt={job}
          className="w-full h-full object-cover rounded-t-xl"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "https://placehold.co/600x400/CCCCCC/333333?text=Image+Not+Found";
          }}
        />
      </div>

      <div className="p-5 flex-grow flex flex-col justify-between">
        <h3 className="text-xl font-semibold text-gray-800 mb-2 text-left">{job}</h3>
        <div className="flex items-center text-gray-600 text-sm mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-1"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" /><circle cx="12" cy="10" r="3" /></svg>
          <span>{location}</span>
        </div>
        <div  className="text-gray-600 text-sm font-medium hover:text-red-600 transition-colors duration-200 flex items-center group">{id}</div>
        <a
          href="#"
          className="text-[#173d73] font-medium hover:text-red-600 transition-colors duration-200 flex items-center group"
        >
          View Details
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ml-1 transition-transform duration-200 group-hover:translate-x-1"><path d="m5 12 7-7 7 7" /><path d="M12 19V5" /></svg>
        </a>
      </div>
    </div>
  );
};

export default CareerCard;